import request from "@/utils/request";

export function getTicketInfo(data) {
  return request({
    url: "/ticket/info/",
    method: "POST",
    data: data
  });
}

export function getTicketFocus() {
  return request({
    url: "/ticket/focus/",
    method: "POST"
  });
}
